export default __webpack_public_path__ + "static/HD_Camera_Alarm_Relay-b04f0da60008d0ce4d52151282cb2b5c.webp";